// extracted by mini-css-extract-plugin
export var axisLabelBottom = "Charts-module--axis-label-bottom--5a0b3";
export var axisLabelLeft = "Charts-module--axis-label-left--242a9";
export var axisTicks = "Charts-module--axis-ticks--6756b";
export var container = "Charts-module--container--8104f";
export var graphContainer = "Charts-module--graph-container--cd3e6";
export var legend = "Charts-module--legend--a8752";
export var legendShape = "Charts-module--legend-shape--36ba1";
export var pieChartLabel = "Charts-module--pie-chart-label--32d00";
export var pieChartLabelNumber = "Charts-module--pie-chart-label-number--f426c";
export var pieChartLegend = "Charts-module--pie-chart-legend--527fa";
export var srOnly = "Charts-module--sr-only--3097c";